import { Opgavepakke } from './Opgavepakke'; 
import { KonkurrencestatusEnum } from './enums/KonkurrencestatusEnum';
import { EksternBruger } from './EksternBruger';
export class Konkurrence {
        public id: string;
        public kommunenumre: number[];
        public startdato: Date;
        public synligFraDato: Date;
        public titel: string;
        public beskrivelse: string;
        public afviklingssted: string;
        public adresse: string;
        public postnummer: number;
        public bynavn: string;
        public maxAntalHold: number;
        public antalTilmeldteHold: number;
        public antalHoldPaaVenteliste: number;
        public skoleAar: number;
        public billedId: string;
        public opgavepakker: Opgavepakke[];
        public eksterne: EksternBruger[]; 
        public status: KonkurrencestatusEnum;
        public readonly: boolean;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/Konkurrence.ts